import { render } from "./Help.vue?vue&type=template&id=2de9f684"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__